import { useCallback, useState } from "react";
import { FormState, UserInterfaceState } from "../../../../shared/Enum";

import { LocationEntity } from "../../../../api/Locations/Entity/LocationEntity";
import {
  getLocationDetail,
  updateLocation,
} from "../../../../api/Locations/Repository";
import { UpdateLocationFormData } from "../../../../api/Locations";
import { enqueueSnackbar } from "notistack";

interface Return {
  data: {
    uiState: UserInterfaceState;
    formState: FormState;
    locationDetail: LocationEntity;
  };
  method: {
    onGetLocationDetail(id: string): void;
    onUpdateLocation(payload: UpdateLocationFormData): void;
  };
}

export default function useViewModel(): Return {
  const [uiState, setUiState] = useState<UserInterfaceState>(
    UserInterfaceState.Idle
  );
  const [formState, setFormState] = useState<FormState>(FormState.Idle);
  const [locationDetail, setLocationDetail] = useState<LocationEntity>({
    locationId: "",
    imageUrl: "",
    address: "",
    bmName: "",
    ext: "",
    email: "",
    locationName: "",
    manager: { name: "", phone: "", position: "" },
    mission: [""],
    personInCharge: [{ name: "", phone: "", position: "" }],
    phone: "",
    strategy: [""],
    vision: "",
    imageName: "",
  });

  const onGetLocationDetail = useCallback(
    async (id: string) => {
      setUiState(UserInterfaceState.Loading);
      await getLocationDetail(id)
        .then((res) => setLocationDetail(res))
        .then(() => setUiState(UserInterfaceState.Success))
        .catch((error) => {
          console.log("Error fetching data:", error);
          setUiState(UserInterfaceState.Error);
        });
    },
    [getLocationDetail]
  );

  const onUpdateLocation = useCallback(
    async (payload: UpdateLocationFormData) => {
      setFormState(FormState.Loading);
      await updateLocation(payload)
        .then(() => {
          setFormState(FormState.Success);
          enqueueSnackbar("Location updated successfully.", {
            variant: "success",
          });
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
          setFormState(FormState.Error);
        });
    },
    [updateLocation]
  );

  return {
    data: {
      uiState,
      formState,
      locationDetail,
    },
    method: { onGetLocationDetail, onUpdateLocation },
  };
}
